<template src="./TarjetaPaciente.html"></template>

<script>
export default {
  data() {
    return {
      namePatient: ""
    };
  },
  computed: {
    nombrePaciente() {
      if (this.patientInformation) {
        return `${this.patientInformation[0].valor} ${this.patientInformation[1].valor}`;
      }
      return null;
    }
  },
  props: {
    patientInformation: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style src="./TarjetaPaciente.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/Terapias/TarjetaPaciente/TarjetaPaciente.vue